import { colors, spacing, radius, shadows, typography } from "../theme";

export default function OperationsCoach({
  title = "ShiftBridge Operations Coach",
  subtitle = "Today's operational priorities",
  items = [],
  estimatedMinutes = 5,
}) {
  return (
    <div
      style={{
        background: "#eff6ff",
        border: "1px solid #bfdbfe",
        borderRadius: radius.xl,
        boxShadow: shadows.sm,
        padding: spacing.lg,
      }}
    >
      <div style={{ ...typography.title, color: "#1e3a8a" }}>
        🤖 {title}
      </div>

      <div
        style={{
          ...typography.subtitle,
          color: colors.slate700,
          marginTop: spacing.xs,
        }}
      >
        {subtitle}
      </div>

      <div style={{ display: "grid", gap: spacing.sm, marginTop: spacing.md }}>
        {items.length ? (
          items.map((item, index) => (
            <button
              key={`${item.label}-${index}`}
              type="button"
              onClick={item.onClick}
              style={{
                width: "100%",
                textAlign: "left",
                border: `1px solid ${item.border || "#bfdbfe"}`,
                background: item.bg || colors.white,
                color: item.color || colors.slate900,
                borderRadius: radius.lg,
                padding: "10px 12px",
                fontWeight: 950,
                cursor: item.onClick ? "pointer" : "default",
              }}
            >
              {item.label}
            </button>
          ))
        ) : (
          <div style={{ color: colors.success, fontWeight: 900 }}>
            🟢 No urgent actions right now.
          </div>
        )}
      </div>

      <div
        style={{
          marginTop: spacing.md,
          ...typography.caption,
          color: colors.slate500,
        }}
      >
        Estimated workload: {estimatedMinutes} minutes
      </div>
    </div>
  );
}